<div class="navbar-wrapper" [class.collapsed]="isCollapsed$.value">
  <div class="logo-container">
    <img src="assets/img/start-page/HVB_Logo.svg" class="cursor-pointer"
         (click)="router.navigate([Route.HOME])" alt="HVB Logo"/>
  </div>
  <nav class="navbar-navigation">
    <div style="flex-grow: 1" *ngIf="(authenticated$|async)">
      <a class="nav-link" [routerLink]="Route.INSERATE"
         *ngIf="(userType$ | async) === Roles.ROLE_INSURER || (userType$ | async) === Roles.ROLE_BROKER
         || (userType$ | async) === Roles.ROLE_UNDERWRITER || (userIsBusinessAdmin$ | async) === true
         || (user$ | async).representedUsers.length > 0"
         routerLinkActive="active-link"
         data-cy="nav-overview">
        <img [src]="'assets/svg-icons/card-collection' + isActiveRoute(Route.INSERATE) + '.svg'"
             alt="{{'nav.advertisements_offerCreator' | translate}}" class="icon"/>
        <span class="hide-on-collapse">{{'nav.advertisements_offerCreator' | translate}}</span>
      </a>


      <a class="nav-link" [routerLink]="Route.INSERAT_ERSTELLEN"
         *ngIf="(userType$ | async) === Roles.ROLE_INSURER || (userType$ | async) === Roles.ROLE_BROKER || (userType$ | async) === Roles.ROLE_UNDERWRITER"
         routerLinkActive="active-link">
        <img [src]="'assets/svg-icons/new-ad' + isActiveRoute(Route.INSERAT_ERSTELLEN) + '.svg'"
             alt="{{'nav.createAdvertisement' | translate}}" class="icon"/>
        <span class="hide-on-collapse">{{'nav.createAdvertisement' | translate}}</span>
      </a>
    </div>

    <div class="w-100">
      <a *ngIf="!(authenticated$|async)" class="nav-link" [routerLink]="Route.LOGIN" routerLinkActive="active-link">
        <img [src]="'assets/svg-icons/login-circle' + isActiveRoute(Route.LOGIN) + '.svg'"
             alt="{{'loginPage.login' | translate}}" class="icon"/>
        <span class="hide-on-collapse">{{'loginPage.login' | translate}}</span></a>

      <ng-container *ngIf="authenticated$|async">

        <a class="nav-link cursor-pointer" [routerLink]="Route.MAILINGS" *ngIf="(roles$|async).includes(Roles.ROLE_ADMIN) || (roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
           routerLinkActive="active-link">
          <img [src]="'assets/svg-icons/at-sign' + isActiveRoute(Route.MAILINGS) + '.svg'"
               alt="{{'nav.mailings' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.mailings' | translate}}</span></a>

        <a class="nav-link cursor-pointer" [routerLink]="Route.MEMBER_OVERVIEW" *ngIf="!(roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN)"
           routerLinkActive="active-link">
          <img [src]="'assets/svg-icons/memberlist' + isActiveRoute(Route.MEMBER_OVERVIEW) + '.svg'"
               alt="{{'nav.memberOverview' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.memberOverview' | translate}}</span></a>

        <a class="nav-link cursor-pointer" [routerLink]="Route.BILL_BOARD" *ngIf="!(roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN)"
           routerLinkActive="active-link">
          <img [src]="'assets/svg-icons/billboard' + isActiveRoute(Route.BILL_BOARD) + '.svg'"
               alt="{{'nav.billBoard' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.billBoard' | translate}}</span></a>

        <app-user-info style="height: 56px;"></app-user-info>

        <a class="d-flex align-items-center nav-link cursor-pointer" [routerLink]="Route.COMPANY_PROFILE+ '/' + (company$|async).companyId"
           *ngIf="(roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN)"
           routerLinkActive="active-link">
          <img class="rounded-circle profile-picture"
               [src]="'assets/img/profile/default-profile-icon.png'"
               alt="Avatar"/>
          <div class="company-name ms-2 hide-on-collapse">{{(company$|async).name}}</div></a>

        <a class="nav-link cursor-pointer" [routerLink]="Route.HELP"
        *ngIf="(roles$|async).includes(Roles.ROLE_INSURER) ||
               (roles$|async).includes(Roles.ROLE_BROKER) ||
               (roles$|async).includes(Roles.ROLE_UNDERWRITER) ||
               (roles$|async).includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN) ||
               (roles$|async).includes(Roles.ROLE_CORPORATE_ADMIN) ||
               (roles$|async).includes(Roles.ROLE_ADMIN) ||
               (roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)"
           routerLinkActive="active-link">
          <img [src]="'assets/svg-icons/help' + isActiveRoute(Route.HELP) + '.svg'"
               alt="{{'nav.help' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.help' | translate}}</span></a>

        <a class="nav-link cursor-pointer" [routerLink]="Route.ACCOUNT + '/' + (userId$|async)"
           routerLinkActive="active-link"
           data-cy="nav-account">
          <img [src]="'assets/svg-icons/configure' + isActiveRoute(Route.ACCOUNT) + '.svg'"
               alt="{{'nav.account' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.account' | translate}}</span></a>

        <a *ngIf="(roles$|async).includes(Roles.ROLE_ADMIN)" class="nav-link cursor-pointer"
           (click)="redirectToNMS()"
           routerLinkActive="active-link">
          <img [src]="'assets/svg-icons/chart-pie' + isActiveRoute(Route.NMS) + '.svg'"
               alt="{{'nav.administrativeUI' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'nav.administrativeUI' | translate}}</span></a>

        <a class="nav-link cursor-pointer" (click)="logout()">
          <img [src]="'assets/svg-icons/logout-circle.svg'"
               alt="{{'loginPage.logout' | translate}}" class="icon"/>
          <span class="hide-on-collapse">{{'loginPage.logout' | translate}}</span></a>
      </ng-container>
    </div>
    <hr class="navbar-separator ">
    <div class="py-3 arrow-container d-flex nav-link" (click)="toggleCollapse()">
      <mat-icon class="icon show-on-collapse">arrow_forward</mat-icon>
      <mat-icon class="icon hide-on-collapse">arrow_backward</mat-icon>
      <span class="hide-on-collapse">{{'nav.minimize' | translate}}</span>
    </div>
  </nav>

</div>



